/**
 * REChecklist desk → DreamHome Journey session handoff (cross-origin URL params).
 * Trusted desk user ids and demo emails map to Journey manual access without a second sign-in.
 */

export const DESK_HANDOFF_ROLES = ["buyer", "seller", "agent", "broker", "admin"];

/** userId → allowed desk roles + Journey session profile */
export const TRUSTED_DESK_USERS = {
  "admin-dev": { roles: ["admin"], email: "admin@dreamhome.local", name: "Dev Admin" },
  "admin-site": { roles: ["admin"], email: "siteadmin@rechecklist.pro", name: "Site Admin" },
  "buyer-demo": { roles: ["buyer"], email: "buyer@dreamhome.local", name: "Demo Buyer" },
  "buyer-admin": { roles: ["buyer"], email: "admin@dreamhome.local", name: "Dev Admin" },
  "buyer-broker-demo": { roles: ["buyer"], email: "buyer@dreamhome.local", name: "Demo Buyer" },
  "seller-demo": { roles: ["seller"], email: "seller@dreamhome.local", name: "Demo Seller" },
  "agent-demo": { roles: ["agent"], email: "agent@dreamhome.local", name: "Jordan Hale" },
  "agent-demo-2": { roles: ["agent"], email: "agent2@dreamhome.local", name: "Sam Ortiz" },
  "broker-demo": { roles: ["broker"], email: "broker@dreamhome.local", name: "Morgan Ellison" },
};

function profileByEmail(email, role) {
  const key = String(email || "").trim().toLowerCase();
  if (!key) return null;
  return Object.values(TRUSTED_DESK_USERS).find(
    (row) => row.email.toLowerCase() === key && row.roles.includes(role)
  );
}

function buildSession({ role, email, name, deskUserId }) {
  return {
    email,
    role,
    name,
    deskUserId,
    handoff: true,
    at: Date.now(),
  };
}

export function sessionFromDeskHandoff({ role, user, deskEmail }) {
  if (!role || !user || !DESK_HANDOFF_ROLES.includes(role)) return null;

  const trusted = TRUSTED_DESK_USERS[user];
  if (trusted?.roles.includes(role)) {
    return buildSession({
      role,
      email: trusted.email,
      name: trusted.name,
      deskUserId: user,
    });
  }

  const demo = profileByEmail(deskEmail, role);
  if (demo) {
    return buildSession({
      role,
      email: demo.email,
      name: demo.name,
      deskUserId: user,
    });
  }

  return null;
}

export function readDeskHandoffFromSearch(search) {
  const params = new URLSearchParams(search || "");
  return sessionFromDeskHandoff({
    role: params.get("role") || "",
    user: params.get("user") || "",
    deskEmail: params.get("deskEmail") || "",
  });
}
